module.exports = __webpack_public_path__ + "static/img/INTL_OFF_PAYMENT.43b95ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sureOrder/INTL_OFF_PAYMENT.svg
// module id = sjv4
// module chunks = 0